import React from 'react';
import { useTranslation } from 'react-i18next';
import WhatsAppIcon from './icons/WhatsAppIcon';

const WA_CHANNEL_URL = 'https://whatsapp.com/channel/0029VbCLDrO9sBI7ig4vK60T';

// Stations on the Metz ↔ Thionville ↔ Luxembourg corridor (and a few intermediates).
const CORRIDOR = new Set([
  'metz',
  'metz ville',
  'metz nord',
  'woippy',
  'hagondange',
  'uckange',
  'thionville',
  'hettange-grande',
  'bettembourg',
  'luxembourg',
]);

// Strip "City (Region)" → "City" and lowercase for matching.
const normalize = (s) => (s || '')
  .replace(/\s*\([^)]*\)\s*$/, '')
  .trim()
  .toLowerCase();

/** True when both endpoints (current station + train's other end) are on the corridor. */
export const isOnMetzLuxLine = (stationName, train) => {
  const a = normalize(stationName);
  const b = normalize(train?.destination || train?.origin);
  return CORRIDOR.has(a) && CORRIDOR.has(b);
};

/**
 * Badge shown only for delayed trains running on the Metz ↔ Thionville ↔ Luxembourg
 * corridor. Links to the official Fluo Grand Est WhatsApp channel for live info.
 */
const WhatsAppChannelBadge = ({ station, train }) => {
  const { t } = useTranslation();
  if (!train || train.status !== 'delayed') return null;
  if (!isOnMetzLuxLine(station, train)) return null;

  return (
    <a
      href={WA_CHANNEL_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="wa-channel-badge"
      title={t('wa_channel.tooltip')}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-bold tracking-wide bg-[#25D366] text-white border border-[#1ebe57] hover:bg-[#1ebe57] transition-colors"
    >
      <WhatsAppIcon className="w-3 h-3" />
      {t('wa_channel.label')}
    </a>
  );
};

export default WhatsAppChannelBadge;
